import { useEffect, useReducer, useState } from "react";
import { Accordion, Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { detailQuestEventPreset } from "../../config/apiSPA";

function reducer(state, action) {
  switch (action.type) {
    case "eventTitle":
      return { ...state, eventTitle: action.value };
    case "prePost":
      return { ...state, prePost: action.value };
    case "share":
      return { ...state, share: action.value };
    case "release":
      return { ...state, release: action.value };
    case "randomMc":
      return { ...state, randomMc: action.value };
    case "randomTf":
      return { ...state, randomTf: action.value };
    case "randomMatch":
      return { ...state, randomMatch: action.value };
    case "balanced":
      return { ...state, balanced: action.value };
    case "scoreMc":
      return { ...state, scoreMc: action.value };
    case "scoreTf":
      return { ...state, scoreTf: action.value };
    case "scoreMatch":
      return { ...state, scoreMatch: action.value };
    case "limitMc":
      return { ...state, limitMc: action.value };
    case "limitTf":
      return { ...state, limitTf: action.value };
    case "validHour":
      return { ...state, validHour: action.value };
    case "validMinutes":
      return { ...state, validMinutes: action.value };
    case "timer":
      return { ...state, timer: action.value };
  }
}
const initialValue = {
  eventTitle: "",
  prePost: "post",
  share: false,
  release: true,
  randomMc: false,
  randomTf: false,
  randomMatch: false,
  balanced: true,
  scoreMc: 0,
  scoreTf: 0,
  scoreMatch: 0,
  limitMc: 0,
  limitTf: 0,
  validHour: 0,
  validMinutes: 0,
  timer: 0,
};

function ModalGenerateEvent({ show, onHide, id, submitClick }) {
  const [values, dispatch] = useReducer(reducer, initialValue);
  const [qtyMc, setQtyMc] = useState(0);
  const [qtyTf, setQtyTf] = useState(0);
  const [qtyMatch, setQtyMatch] = useState(0);
  const [maxLimMc, setMaxLimMc] = useState(0);
  const [maxLimTf, setMaxLimTf] = useState(0);
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [scoreStatus, setScoreStatus] = useState(false);
  const [timerStatus, setTimerStatus] = useState(true);

  function initialValue2(data) {
    dispatch({ type: "eventTitle", value: initialValue.eventTitle });
    dispatch({ type: "prePost", value: initialValue.prePost });
    dispatch({ type: "share", value: initialValue.share });
    dispatch({ type: "release", value: initialValue.release });
    dispatch({ type: "randomMc", value: initialValue.randomMc });
    dispatch({ type: "randomTf", value: initialValue.randomTf });
    dispatch({ type: "randomMatch", value: initialValue.randomMatch });
    dispatch({ type: "balanced", value: initialValue.balanced });
    dispatch({ type: "scoreMc", value: initialValue.scoreMc });
    dispatch({ type: "scoreTf", value: initialValue.scoreTf });
    dispatch({ type: "scoreMatch", value: initialValue.scoreMatch });
    dispatch({ type: "limitMc", value: initialValue.limitMc });
    dispatch({ type: "limitTf", value: initialValue.limitTf });
    dispatch({ type: "validHour", value: initialValue.validHour });
    dispatch({ type: "validMinutes", value: initialValue.validMinutes });
    dispatch({ type: "timer", value: initialValue.timer });
  }

  function questionDataPreset(data) {
    setQtyMc(data.qtyMc);
    setQtyTf(data.qtyTf);
    setQtyMatch(data.qtyMatch);

    dispatch({ type: "limitMc", value: data.qtyMc });
    setMaxLimMc(data.qtyMc);
    dispatch({ type: "limitTf", value: data.qtyTf });
    setMaxLimTf(data.qtyTf);
  }
  function handleOnShow() {
    setLoading(true);
    initialValue2();
    setDisabled(true);
    detailQuestEventPreset(id).then((res) => {
      questionDataPreset(res.data);
      setLoading(false);
    });
  }

  function handleHide() {
    initialValue2();
    onHide();
  }
  function hanldleChangePrePost(mode, val) {
    if (mode === "post" && val) {
      dispatch({ type: "prePost", value: "post" });
    }
    if (mode === "pre" && val) {
      dispatch({ type: "prePost", value: "pre" });
    }
  }

  function handleChangeScoreMode(val) {
    dispatch({ type: "balanced", value: val.balanced });
    dispatch({ type: "scoreMc", value: val.mc });
    dispatch({ type: "scoreTf", value: val.tf });
    dispatch({ type: "scoreMatch", value: val.match });
    setScoreStatus(val.status);
  }

  function handleTimerChange(val) {
    dispatch({ type: "timer", value: val.val });
    setTimerStatus(val.status);
  }

  useEffect(() => {
    setDisabled(values.eventTitle && scoreStatus && values.validHour + values.validMinutes && timerStatus ? false : true);
  }, [values, scoreStatus, timerStatus]);
  return (
    <>
      <Modal show={show} size="lg" onShow={() => handleOnShow()} onHide={() => handleHide()}>
        <ModalHeader closeButton>
          <h5 className="modal-title">Create Your Event</h5>
        </ModalHeader>
        <ModalBody>
          {loading ? (
            <p>Loading.....</p>
          ) : (
            <>
              <div className="form-group mb-3">
                <label className="form-label" htmlFor="title">
                  Event Title
                </label>
                <input type="text" className="form-control" onChange={(e) => dispatch({ type: "eventTitle", value: e.target.value })} placeholder="Post Test PM/PK PC9100-8" id="title" />
              </div>
              <div className="form-check mb-2">
                <input onChange={(e) => hanldleChangePrePost("pre", e.target.checked)} className="form-check-input" name="type" type="radio" id="pre" />
                <label className="form-check-label" htmlFor="pre">
                  Pre Test
                </label>
              </div>
              <div className="form-check mb-3">
                <input onChange={(e) => hanldleChangePrePost("post", e.target.checked)} className="form-check-input" name="type" type="radio" defaultChecked={true} id="post" />
                <label className="form-check-label" htmlFor="post">
                  Post Test
                </label>
              </div>
              <div className="form-check form-switch mb-2">
                <input type="checkbox" onChange={(e) => dispatch({ type: "share", value: e.target.checked })} className="form-check-input" defaultChecked={values.share} id="share" />
                <label className="form-check-label" htmlFor="share">
                  Share to all
                </label>
              </div>
              <div className="form-check form-switch mb-3">
                <input type="checkbox" onChange={(e) => dispatch({ type: "release", value: e.target.checked })} className="form-check-input" defaultChecked={values.release} id="release" />
                <label className="form-check-label" htmlFor="release">
                  Release Result
                </label>
              </div>
              <div className="form-check form-switch mb-2">
                <input type="checkbox" onChange={(e) => dispatch({ type: "randomMc", value: e.target.checked })} className="form-check-input" disabled={qtyMc ? false : true} defaultChecked={values.randomMc} id="randomMc" />
                <label className="form-check-label" htmlFor="randomMc">
                  Random Multiple Choice Questions
                </label>
              </div>
              <div className="form-check form-switch mb-2">
                <input type="checkbox" onChange={(e) => dispatch({ type: "randomTf", value: e.target.checked })} className="form-check-input" disabled={qtyTf ? false : true} defaultChecked={values.randomTf} id="randomTf" />
                <label className="form-check-label" htmlFor="randomTf">
                  Random True False Questions
                </label>
              </div>
              <div className="form-check form-switch mb-2">
                <input type="checkbox" onChange={(e) => dispatch({ type: "randomMatch", value: e.target.checked })} className="form-check-input" disabled={qtyMatch ? false : true} defaultChecked={values.randomMatch} id="randomMatch" />
                <label className="form-check-label" htmlFor="randomMatch">
                  Random Matching Questions
                </label>
              </div>
              <hr />
              {/* /////////////////////// Timer Setting //////////////////////////// */}
              <TimerMode onChange={(val) => handleTimerChange(val)} />
              {/* /////////////////////// End Timer Setting //////////////////////////// */}
              <hr />
              <ScoreMode qtyMc={qtyMc} qtyTf={qtyTf} qtyMatch={qtyMatch} onChange={(e) => handleChangeScoreMode(e)} />
              <hr />
              <label className="form-check-label" htmlFor="limitMcid">
                Limit Questions (Multiple Choice) : {values.limitMc}
              </label>
              <input type="range" className="form-range" onChange={(e) => dispatch({ type: "limitMc", value: e.target.value })} max={maxLimMc} defaultValue={maxLimMc} id="limitMcid" />
              <label className="form-check-label" htmlFor="limitTf">
                Limit Questions (True False) : {values.limitTf}
              </label>
              <input type="range" className="form-range" onChange={(e) => dispatch({ type: "limitTf", value: e.target.value })} max={maxLimTf} defaultValue={maxLimTf} id="limitTf" />
              <hr />
              <div className="mb-2">
                <label className="form-check-label text-theme" htmlFor="balanced">
                  This Event Valid Until:
                </label>
              </div>
              <label className="form-check-label" htmlFor="limitMcid">
                Hour : {values.validHour} h
              </label>
              <input type="range" className="form-range" onChange={(e) => dispatch({ type: "validHour", value: parseInt(e.target.value) })} max={4} defaultValue={0} id="limitMcid" />
              <label className="form-check-label" htmlFor="limitTf">
                Minutes : {values.validMinutes} m
              </label>

              <input type="range" className="form-range" onChange={(e) => dispatch({ type: "validMinutes", value: parseInt(e.target.value) })} min={0} max={60} defaultValue={0} id="limitTf" />
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <button type="button" onClick={() => submitClick(values)} disabled={disabled} className="btn btn-outline-theme">
            Create
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ModalGenerateEvent;

function ScoreMode({ qtyMc, qtyTf, qtyMatch, onChange }) {
  const [balancedStatus, setBalancedStatus] = useState(true);
  const [balBtnDisabled, setBalBtnDisabled] = useState(true);
  const [mcSc, setmcSc] = useState(0);
  const [tfSc, settfSc] = useState(0);
  const [matchSc, setMatchSc] = useState(0);
  const [totalScore, setTotalScore] = useState(0);
  const [scoreDisabled, setscoreDisabled] = useState({ mc: true, tf: true, match: true });
  function handleBalancedCheck(val) {
    setBalancedStatus(val);
  }
  function handleChangeSoalMc(val) {
    setmcSc(val);
  }
  function handleChangeSoalTf(val) {
    settfSc(val);
  }
  function handleChangeSoalMatch(val) {
    setMatchSc(val);
  }
  function disabledBalanceBtn() {
    const mc = qtyMc > 0 ? 1 : 0;
    const tf = qtyTf > 0 ? 1 : 0;
    const match = qtyMatch > 0 ? 1 : 0;
    if (mc + tf + match < 2) return true;
    return false;
  }

  useEffect(() => {
    setBalBtnDisabled(disabledBalanceBtn());
  }, []);
  useEffect(() => {
    setTotalScore(mcSc + tfSc + matchSc);
    setscoreDisabled({
      mc: qtyMc > 0 ? false : true,
      tf: qtyTf > 0 ? false : true,
      match: qtyMatch > 0 ? false : true,
    });
    onChange({
      balanced: balancedStatus,
      mc: mcSc,
      tf: tfSc,
      match: matchSc,
      status: balancedStatus ? true : mcSc + tfSc + matchSc === 100 ? true : false,
    });
  }, [mcSc, tfSc, matchSc, balancedStatus]);
  return (
    <>
      <div className="form-check mb-3">
        <input disabled={balBtnDisabled} onChange={(e) => handleBalancedCheck(e.target.checked)} className="form-check-input" type="checkbox" defaultChecked={balancedStatus} id="balanced" />
        <label className="form-check-label" htmlFor="balanced">
          Balanced Score
        </label>
      </div>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey={balancedStatus ? "1" : "0"}>
          <Accordion.Body>
            <label className="form-check-label">Total Score</label>
            <div className="progress">
              <div className={totalScore < 100 || totalScore > 100 ? "progress-bar bg-danger" : "progress-bar"} style={{ width: totalScore + "%" }}>
                {totalScore}%
              </div>
            </div>
            <div className="small text-danger text-opacity-50 mb-2">Make sure the total score is 100%</div>
            <label className="form-check-label" htmlFor="scoreMc">
              Multiple Choice Score:{mcSc}%
            </label>
            <input type="range" disabled={scoreDisabled.mc} onChange={(e) => handleChangeSoalMc(parseInt(e.target.value))} defaultValue={0} className="form-range" id="scoreMc" />
            <label className="form-check-label" htmlFor="scoreTf">
              True False Score:{tfSc}%
            </label>
            <input type="range" disabled={scoreDisabled.tf} onChange={(e) => handleChangeSoalTf(parseInt(e.target.value))} defaultValue={0} className="form-range" id="scoreTf" />
            <label className="form-check-label" htmlFor="scoreMatch">
              Matching Score:{matchSc}%
            </label>
            <input type="range" disabled={scoreDisabled.match} onChange={(e) => handleChangeSoalMatch(parseInt(e.target.value))} defaultValue={0} className="form-range" id="scoreMatch" />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
}

function TimerMode({ onChange }) {
  const [timerEnabled, setTimerEnabled] = useState(false);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  function handleChangeTimerStatus(val) {
    setTimerEnabled(val);
  }

  function setTimer() {
    if (timerEnabled) {
      const sec = hours * 3600 + minutes * 60;
      return {
        status: sec > 0 ? true : false,
        val: sec,
      };
    }
    return {
      status: true,
      val: 0,
    };
  }
  useEffect(() => {
    onChange(setTimer());
  }, [hours, minutes, timerEnabled]);
  return (
    <>
      <div className="form-check mb-3">
        <input onChange={(e) => handleChangeTimerStatus(e.target.checked)} className="form-check-input" type="checkbox" id="timer" />
        <label className="form-check-label" htmlFor="timer">
          With Timer
        </label>
      </div>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey={timerEnabled ? "0" : "1"}>
          <Accordion.Body>
            <div className="small  mb-2">
              Timer will be set to {hours} hours, {minutes} minutes
            </div>
            <label className="form-check-label" htmlFor="timerH">
              Hours:
            </label>
            <input onChange={(e) => setHours(e.target.value)} type="range" className="form-range" min={0} max={5} defaultValue={0} id="timerH" />
            <label className="form-check-label" htmlFor="timerM">
              Minutes:
            </label>
            <input onChange={(e) => setMinutes(e.target.value)} type="range" className="form-range" min={0} max={60} defaultValue={0} id="timerM" />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
}
